$('.pdp--availability-wrapper').prependTo('.accordion-store-locator');

/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

$(document).ready(function () {
    const locationAvailability = document.querySelector('.location-availability');

    var krw_store_checker_live;

    function localeLookUp() {
        $.ajax(
            'https://api.ipdata.co?api-key=d84c930bde2431bfd9ac43671bb0af3c9f165981552049803ecd9835',
        ).then(
            function success(response) {
                var current_region = response.region;
                var current_cty = response.city;

                if (current_region === 'New Jersey' || current_region === 'Connecticut') {
                    current_region = 'New York';
                }

                Cookies.set('krw_store_checker_live', current_region, { expires: 1 });
                Cookies.set('krw_checked_locale', true, { expires: 1 });

                krw_store_checker_live = Cookies.get('krw_store_checker_live');

                ////console.log'Initial Check: ' + krw_store_checker_live);

                // Show stores in same state
                $(
                    '.pdp--location:not([data-store-state="' + krw_store_checker_live + '"])',
                ).remove();
                $('.pdp--location[data-store-state="' + krw_store_checker_live + '"]').css(
                    'display',
                    'inline-block',
                );

                // Move closes city location to top
                if ($('.pdp--location[data-store-city="' + current_cty + '"]').length) {
                    $('body').addClass('pdp--local-location-active');

                    $('.pdp--location[data-store-city="' + current_cty + '"]').prependTo(
                        '.pdp--availability-wrapper',
                    );
                }

                $('.pdp--location:visible:last').addClass('last-store');

                // Check number of stores found
                var numberOfStoresFound = $(
                    '.pdp--location[data-store-state="' + krw_store_checker_live + '"]',
                ).length;

                // Get all .pdp--location-details-inner elements
                var details = $(
                    '.pdp--location[data-store-state="' +
                        krw_store_checker_live +
                        '"] .pdp--location-details-inner',
                );

                // Find the maximum height
                var maxAddressHeight = 0;
                details.each(function () {
                    var height = $(this).find('.pdp--location-address').outerHeight();
                    if (height > maxAddressHeight) {
                        maxAddressHeight = height;
                    }
                });

                // Set each .pdp--location-address to the maximum height
                details.each(function () {
                    $(this).find('.pdp--location-address').height(maxAddressHeight);
                });

                if ($(window).width() > 990) {
                    var body = document.body;

                    var availabilityContainers = document.querySelectorAll(
                        '.pdp--availability-wrapper',
                    );

                    availabilityContainers.forEach(function (container) {
                        var isDown = false;
                        var isDragged = false; // New variable to track dragging
                        var startX;
                        var scrollLeft;

                        container.addEventListener('mousedown', function (e) {
                            isDown = true;
                            isDragged = false; // Reset on mousedown
                            container.classList.add('active');
                            body.classList.add('carousel-cursor');
                            startX = e.pageX - container.offsetLeft;
                            scrollLeft = container.scrollLeft;
                        });

                        container.addEventListener('mousemove', function (e) {
                            if (!isDown) return;
                            e.preventDefault();
                            isDragged = true; // Set to true if mousemove occurs
                            var x = e.pageX - container.offsetLeft;
                            var walk = (x - startX) * 3;
                            container.scrollLeft = scrollLeft - walk;
                        });

                        container.addEventListener('mouseup', endAvailabilityScrolling);
                        container.addEventListener('mouseleave', endAvailabilityScrolling);

                        // New click event listener to prevent click if dragged
                        container.addEventListener('click', function (e) {
                            if (isDragged) {
                                e.preventDefault();
                            }
                        });

                        function endAvailabilityScrolling() {
                            isDown = false;
                            container.classList.remove('active');
                            body.classList.remove('carousel-cursor');
                        }
                    });

                    var availabilityRectangles = document.querySelectorAll(
                        '.accordion-store-locator .carousel-rectangle',
                    );

                    availabilityRectangles.forEach(function (rectangle) {
                        rectangle.addEventListener('mousedown', function (e) {
                            rectangle.classList.add('active');
                            body.classList.add('carousel-cursor');
                            var startX = e.pageX;
                            var carouselId = rectangle.closest('.carousel-track-wrapper').dataset
                                .carouselId;
                            var carousel = document.querySelector(
                                '.pdp--availability-wrapper[data-carousel-id="' +
                                    carouselId +
                                    '"]',
                            );
                            var scrollLeft = carousel.scrollLeft;

                            function onMouseMove(e) {
                                e.preventDefault();
                                var x = e.pageX;
                                var walk = (x - startX) * 3;
                                carousel.scrollLeft = scrollLeft + walk;
                            }

                            function onMouseUp() {
                                rectangle.classList.remove('active');
                                body.classList.remove('carousel-cursor');
                                document.removeEventListener('mousemove', onMouseMove);
                                document.removeEventListener('mouseup', onMouseUp);
                            }

                            document.addEventListener('mousemove', onMouseMove);
                            document.addEventListener('mouseup', onMouseUp);
                        });
                    });
                }

                $('.accordion-wrapper.product-shop-availability .accordion-title').addClass(
                    'active',
                );
                setTimeout(function () {
                    // Get all .pdp--location-details-inner elements

                    if (numberOfStoresFound === 0) {
                        $('.accordion-store-locator')
                            .parents('.product__accordion')
                            .css('display', 'none');
                    }
                }, 300);
            },
            function fail(data, status, response) {
                //console.log"Request failed.  Returned status of", status + response);
            },
        );
    }

    if (!Cookies.get('krw_checked_locale_live')) {
        ////console.log'First locale check');
        localeLookUp();
    }

    if (Cookies.get('krw_checked_locale_live') === 'true') {
        var krw_store_checker_history_live = Cookies.get('krw_store_checker_live');

        $(
            '.pdp--location:not([data-store-state="' + krw_store_checker_history_live + '"])',
        ).remove();
        $('.pdp--location[data-store-state="' + krw_store_checker_history_live + '"]').css(
            'display',
            'inline-block',
        );

        ////console.log'Already checked: ' + krw_store_checker_history_live);

        $('.pdp--location:visible:last').addClass('last-store');

        // Move closes city location to top
        //$('.pdp--location[data-store-city="'+current_cty+'"]').prependTo('.pdp--availability-wrapper');

        // Check number of stores found
        var numberOfStoresFound_history_live = $(
            '.pdp--location[data-store-state="' + krw_store_checker_history_live + '"]',
        ).length;

        setTimeout(function () {
            // Get all .pdp--location-details-inner elements
            var details = $(
                '.pdp--location[data-store-state="' +
                    krw_store_checker_history_live +
                    '"] .pdp--location-details-inner',
            );

            // Find the maximum height
            var maxAddressHeight = 0;
            details.each(function () {
                var height = $(this).find('.pdp--location-address').outerHeight();
                if (height > maxAddressHeight) {
                    maxAddressHeight = height;
                    //console.log('Edited max height');
                }
            });
            if (numberOfStoresFound_history_live === 0) {
                $('body').addClass('location-inventory-hidden');
                $('#shopify-section-component-location-inventory').css('display', 'none');
            }
        }, 300);
    }

    function updateLocationAvailability() {
        let inStockCount = 0;
        let limitedInventoryCount = 0;
        let outOfStockCount = 0;

        document.querySelectorAll('.pdp--location').forEach((location) => {
            const stockIcon = location.querySelector('.stock-check i');

            if (stockIcon) {
                const iconClass = stockIcon.className;

                if (iconClass === 'limited-inventory') {
                    limitedInventoryCount++;
                } else if (iconClass === 'is-out-of-stock') {
                    outOfStockCount++;
                } else {
                    // No class means in-stock
                    inStockCount++;
                }
            }
        });

        const locationAvailability = document.querySelector('.location-availability');

        if (inStockCount > 0) {
            locationAvailability.setAttribute('data-availability', 'in-stock');
            locationAvailability.setAttribute('aria-label', 'In-stock in a store near you');
        } else if (limitedInventoryCount > 0) {
            locationAvailability.setAttribute('data-availability', 'try-on-only');
            locationAvailability.setAttribute(
                'aria-label',
                'Available for try-on only in a store near you',
            );
        } else if (outOfStockCount > 0) {
            locationAvailability.setAttribute('data-availability', 'out-of-stock');
            locationAvailability.setAttribute('aria-label', 'Not available in a store near you');
        }
    }

    var requestInventory;
    var storeName;
    var storeInventory;

    function checkStoreInventory(variantID) {
        // Abort any pending request
        if (requestInventory) {
            requestInventory.abort();
        }

        //console.log('Checking inventory for variant ID:', variantID);
        var apiUrl = 'https://krw-stores.herokuapp.com/str_inventory?variantID=' + variantID;
        //console.log('Making request to:', apiUrl);

        // Fire off the request to /form.php
        requestInventory = $.ajax({
            url: apiUrl,
            type: 'post',
            data: '',
            beforeSend: function () {
                //console.log('Starting API request...');
            },
        });

        // Callback handler that will be called on success
        requestInventory.done(function (response, textStatus, jqXHR) {
            //console.log('Raw API Response:', response);
            //console.log('Response Status:', textStatus);

            try {
                // Get payload
                var storesData = response;
                var storesDataJSON = JSON.parse(storesData);

                // Log full response
                //console.log('Parsed Response:', storesDataJSON);

                // Check number of stores
                var storesCount = $.map(storesDataJSON, function (n, i) {
                    return i;
                }).length;
                //console.log('Total number of stores:', storesCount);

                for (var i = 0; i < storesDataJSON.length; i++) {
                    storeName = storesDataJSON[i].node.location.name;
                    storeInventory =
                        storesDataJSON[i].node.quantities.find((q) => q.name === 'available')
                            ?.quantity || 0;

                    // Log each store's inventory
                    //console.log('Store:', storeName, 'Inventory Count:', storeInventory);

                    var $store = $(
                        '.pdp--location[data-store-name-internal="' + storeName + '"]',
                    );
                    $store.attr('data-store-inventory', storeInventory);

                    //console.log('Store inventory: ' + storeInventory)

                    if (storeInventory === 0) {
                        $store.find('.stock-check').fadeOut(function () {
                            if ($('body').hasClass('template-pdp-pre-shop')) {
                                $(this)
                                    .html('<i class="is-out-of-stock"></i>Online Only')
                                    .fadeIn();
                            } else {
                                $(this)
                                    .html('<i class="is-out-of-stock"></i>Out of Stock')
                                    .fadeIn();
                            }
                        });

                        $store.find('.stock-copy').fadeOut(function () {
                            $(this)
                                .html(
                                    "Looks like this was a best seller! Visit us and we'll help you find a similar pair.",
                                )
                                .fadeIn();
                        });
                    } else if (storeInventory === 1) {
                        $store.find('.stock-check').fadeOut(function () {
                            $(this)
                                .html('<i class="limited-inventory"></i>TRY-ON ONLY')
                                .fadeIn();
                        });

                        $store.find('.stock-copy').fadeOut(function () {
                            $(this)
                                .html(
                                    "Great news—come try on IRL and we'll place your order with free 2-day shipping.",
                                )
                                .fadeIn();
                        });
                    } else {
                        $store.find('.stock-check').fadeOut(function () {
                            $(this).html('<i></i>In-Stock').fadeIn();
                        });

                        $store.find('.stock-copy').fadeOut(function () {
                            //console.log($store.attr('data-store-rx-available'));

                            if (
                                $(this)
                                    .parents('.pdp--location')
                                    .attr('data-store-rx-available') === 'true'
                            ) {
                                $(this)
                                    .html(
                                        'Visit us in store to custom fit your frames, explore lens options and fill your RX.',
                                    )
                                    .fadeIn();
                            } else {
                                $(this)
                                    .html(
                                        'Visit us in store to custom fit your frames and explore lens options.',
                                    )
                                    .fadeIn();
                            }
                        });
                    }
                }

                setTimeout(function () {
                    updateLocationAvailability();
                }, 500);
            } catch (e) {
                console.error('Error parsing response:', e);
            }
        });

        // Callback handler that will be called on failure
        requestInventory.fail(function (jqXHR, response, textStatus, errorThrown) {
            // Log the error to the console
            //console.error('API Request Failed:');
            //console.error('Status:', textStatus);
            console.error('Error:', errorThrown);
            //console.error('Response:', response);
            //console.error('Full jqXHR object:', jqXHR);
        });

        // Callback handler that will be called regardless
        // if the request failed or succeeded
        requestInventory.always(function (response) {
            // Reenable the inputs
            //$inputs.prop("disabled", false);
        });
    }

    var initialVariantID = $('#AddToCart').attr('data-variant-id');
    var initialVariantOnlineExclusiveCheck = $('.frame-active button').attr(
        'data-product-online-exclusive',
    );

    //console.log('Initial variant ID:', initialVariantID);
    //console.log('Initial online exclusive check:', initialVariantOnlineExclusiveCheck);

    onload = (event) => {
        if (initialVariantOnlineExclusiveCheck === 'true') {
            $('.store-inventory-block').addClass('pdp-online-exclusive');
            $('.store-inventory-block i').addClass('online-exclusive-inventory');
            $('.stock-check').html('<i class="online-exclusive-inventory"></i>WANNA TRY IT ON?');
            $('.stock-copy').html(
                "This frame is available for you in-store, but only in other colors. If you love the style, we'll order your color with free 2-day shipping.",
            );
            $('.location-availability').attr('data-availability', 'online-exclusive');
            $('.accordion-heading-krewe-store-near-you h3').html(
                'ONLINE EXCLUSIVE <span class="location-availability" data-availability="online-exclusive"></span>',
            );
        } else {
            checkStoreInventory(initialVariantID);
        }
    };

    function updateAccordionLocationCarousels() {
        //console.log'updateCarousels called');
        document
            .querySelectorAll('.accordion-store-locator .pdp--availability-wrapper')
            .forEach((carousel) => {
                const carouselId = carousel.dataset.carouselId;
                const slides = Array.from(carousel.querySelectorAll('.pdp--location')).filter(
                    (slide) => window.getComputedStyle(slide).display !== 'none',
                );

                const track = document.querySelector(
                    `.accordion-store-locator .key-features-track-wrapper[data-carousel-id="${carouselId}"] .carousel-track`,
                );
                const rectangle = track.querySelector('.carousel-rectangle');

                const maxRectangleWidth = 0.4 * track.offsetWidth; // 40% of track width
                const widthPerSlide = track.offsetWidth / slides.length;

                rectangle.style.width = `${Math.min(widthPerSlide, maxRectangleWidth)}px`;

                const trackWidth = track.offsetWidth - rectangle.offsetWidth;

                carousel.addEventListener('scroll', () => {
                    const scrollLeft = carousel.scrollLeft;
                    const scrollWidth =
                        carousel.scrollWidth -
                        slides.reduce(
                            (accum, slide) =>
                                accum +
                                (window.getComputedStyle(slide).display !== 'none'
                                    ? 0
                                    : slide.offsetWidth),
                            0,
                        );
                    const carouselWidth = carousel.offsetWidth;

                    let scrollPercent = scrollLeft / (scrollWidth - carouselWidth);
                    scrollPercent = Math.max(0, Math.min(1, scrollPercent)); // limit scrollPercent between 0 and 1

                    rectangle.style.transform = `translateX(${scrollPercent * trackWidth}px)`;
                });
            });
    }

    $(document).one('click', '.accordion-wrapper-store-locator', function () {
        setTimeout(function () {
            updateAccordionLocationCarousels();
        }, 500);
    });

    var inventoryHoverTimer;
    $('.pdp-family-swatch button').on({
        mouseenter: function () {
            var $this = $(this);
            var storeVariantID = $this.attr('data-variant-id');
            var onlineExclusive = $this.attr('data-product-online-exclusive');

            //console.log('Swatch hover - variant ID:', storeVariantID);
            //console.log('Swatch hover - online exclusive:', onlineExclusive);
            //console.log('Swatch element:', $this[0]); // Log the actual element for inspection

            // Set a timer to delay the hover effect
            inventoryHoverTimer = setTimeout(function () {
                if (onlineExclusive === 'true') {
                    $('.store-inventory-block').addClass('pdp-online-exclusive');
                    $('.store-inventory-block i').addClass('online-exclusive-inventory');
                    $('.stock-check').html(
                        '<i class="online-exclusive-inventory"></i>WANNA TRY IT ON?',
                    );
                    $('.stock-copy').html(
                        "This frame is available for you in-store, but only in other colors. If you love the style, we'll order your color with free 2-day shipping.",
                    );
                    $('.location-availability').attr('data-availability', 'online-exclusive');
                    $('.accordion-heading-krewe-store-near-you h3').html(
                        'ONLINE EXCLUSIVE <span class="location-availability" data-availability="online-exclusive"></span>',
                    );
                } else {
                    $('.accordion-heading-krewe-store-near-you h3').html(
                        'KREWE STORE NEAR YOU <span class="location-availability" data-availability=""></span>',
                    );
                    checkStoreInventory(storeVariantID);
                }
            }, 300); // Match hover interval
        },
        mouseleave: function () {
            // Clear the timer if the mouse leaves the button before the timeout
            clearTimeout(inventoryHoverTimer);
        },
        click: function () {
            // Ensure the functionality triggers immediately on click
            $(this).trigger('mouseenter'); // You might trigger the mouseenter to handle the logic
        },
    });
});
